module.exports = __webpack_public_path__ + "img/empty-cart.f8441f27.png";